import { Tag } from 'src/services/tag/Tag';
import { TagService } from 'src/services/tag/tag.service';
import { getRelPathCopy } from './getRelPathCopy';
import { isParent } from './isParent';

export function duplicateSelected<T extends Tag>(
  tag: T,
  tags: T[],
  tagService: TagService
): T[] {
  const originalTag = tags.find((t) => t.id === tag.id)!;
  const newId = tagService.getNewId();
  const newRelativePath = getRelPathCopy(originalTag.fullPath, tags);
  const newFullPathParts = [...originalTag?.fullPath.split('/').slice(0, -1)];

  newFullPathParts.push(newRelativePath);

  const newFullPath = newFullPathParts?.join('/');

  const duplicatedTag = {
    ...originalTag,
    id: newId,
    fullPath: newFullPath,
  };

  const duplicatedTags = [duplicatedTag];
  let duplicationIndex = tags.indexOf(originalTag) + 1;

  tags.forEach((currentTag) => {
    if (isParent(originalTag.fullPath, currentTag.fullPath)) {
      const duplicatedChildTag = {
        ...currentTag,
        id: tagService.getNewId(),
        fullPath: currentTag.fullPath.replace(
          originalTag.fullPath,
          duplicatedTag.fullPath
        ),
      };
      duplicatedTags.push(duplicatedChildTag);
      duplicationIndex = tags.indexOf(currentTag) + 1;
    }
  });

  tags.splice(duplicationIndex, 0, ...duplicatedTags);
  return tags;
}
